<template>
  <div class="decoration-frame">
    <div>
      <div><span class="thin">ARCHITECTE</span> <span class="sep">/</span> LOGICIEL</div>
      <div class="subtitle">12 ans d'expérience</div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'decoration'
}
</script>

<style scoped>
.decoration-frame {
  position: relative;
  background-color: black;
  background-image: url('../assets/imgs/code4.png');
  background-size: cover;
  background-position: 50% 50%;
  width: 100%;
  height: 32rem;
  text-align: center;
  font-weight: lighter;
  display: flex;
  flex-direction: column;
  align-items: stretch;
  z-index: 2;
}

.decoration-frame div {
  color: white;
  font-size: 3.5rem;
  margin: auto;
  font-weight: normal;
}

.decoration-frame .subtitle {
  font-size: 1.5rem;
  font-weight: 300;
}

.thin {
  font-weight: 300;
}

.sep {
  color: #fd4900;
}
</style>



// WEBPACK FOOTER //
// Decoration.vue?96c25832